import React, { useState } from "react";
import StatusAlert from "../StatusAlert";
import MediaPreviewModal from "../../Modal/MediaPreviewModal";
import { useTranslation } from "../../../context/Internationalization";
import useFileSource from "./useFileSource";

export default function FilePreview({ file, onClose, actions }) {
  const { t } = useTranslation();
  const { url, name, previewKind } = useFileSource(file);
  const [failed, setFailed] = useState(false);
  return (
    <MediaPreviewModal open onClose={onClose} title={name} actions={actions}>
      {failed || !previewKind ? (
        <StatusAlert severity="info">
          {t("file_preview_unavailable")}
        </StatusAlert>
      ) : (
        url &&
        (previewKind === "image" ? (
          <img src={url} alt={name} onError={() => setFailed(true)} />
        ) : (
          <video src={url} controls autoPlay onError={() => setFailed(true)} />
        ))
      )}
    </MediaPreviewModal>
  );
}
